import type DataResponse from '@/types/DataResponse'
import type PaginatedResponse from '@/types/PaginatedResponse'
import type { AxiosResponse } from 'axios'
import { http } from '../plugins/http'
import { BiometricProvider } from '@/types/BiometricProvider'

export interface BiometricProviderCreateRequest {
  name: string
  classpath: string
  credentials?: Record<string, string>
}

export interface BiometricProviderUpdateRequest {
  name: string
  classpath: string
  credentials?: Record<string, string>
}

export default class BiometricProviderService {
  async index(page = 1, filters = '', per_page = 10): Promise<AxiosResponse<PaginatedResponse<BiometricProvider>>> {
    return await http.get<PaginatedResponse<BiometricProvider>>(`/api/v1/office/biometric-providers?page=${page}&per_page=${per_page}${filters}`)
  }

  async show(id: string): Promise<AxiosResponse<DataResponse<BiometricProvider>>> {
    return await http.get<DataResponse<BiometricProvider>>(`/api/v1/office/biometric-providers/${id}`)
  }

  async store(data: BiometricProviderCreateRequest): Promise<AxiosResponse<DataResponse<BiometricProvider>>> {
    return await http.post<DataResponse<BiometricProvider>>(`/api/v1/office/biometric-providers`, data)
  }

  async update(id: string, data: BiometricProviderUpdateRequest): Promise<AxiosResponse<DataResponse<BiometricProvider>>> {
    return await http.put<DataResponse<BiometricProvider>>(`/api/v1/office/biometric-providers/${id}`, data)
  }

  async destroy(id: string): Promise<AxiosResponse<void>> {
    return await http.delete<void>(`/api/v1/office/biometric-providers/${id}`)
  }
}
